import { colors } from 'fitify-ui'
import { TextStyles } from 'fitify-ui-landing/src/components/Text'
import { phone, tabletPortrait } from 'fitify-ui-landing/src/theme/breakpoints'
import styled, { css } from 'styled-components'

export const StyledPromo = styled.div`
  position: relative;
  max-width: 480px;
  border-radius: 4px;
  margin: 40px auto;
  background-color: ${colors.White};

  > span {
    border-radius: 4px 4px 0 0;
  }

  ${TextStyles} {
    overflow-wrap: break-word;
  }

  ${phone(css`
    max-width: 600px;
    margin: 40px 24px;
  `)}
`

export const StyledPromoContent = styled.div`
  padding: 40px;
  line-height: 170%;

  > p {
    margin: 8px 0 16px;
  }
`

export const StyledPromoList = styled.ol`
  padding: 0;
`

export const StyledPromoApps = styled.ol`
  margin: 24px 0;
`

export const StyledPromoStep = styled.li`
  position: relative;
  padding-left: 60px;
  margin-top: 24px;
  color: ${colors.Blue900};
  counter-increment: inst;
  list-style: none;

  a {
    color: ${colors.Blue900};
    text-decoration: underline;
  }

  &::before {
    position: absolute;
    top: -6px;
    left: 0;
    display: inline-block;
    width: 28px;
    height: 28px;
    padding: 5px;
    border: 1px solid #d9dfe8;
    border-radius: 100%;
    background: ${colors.White};
    color: ${colors.Blue900};
    content: counter(inst);
    font-size: 20px;
    font-weight: 700;
    line-height: 28px;
    text-align: center;
    transition: all 0.2s ease-in-out;
  }
`

export const StyledQrContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 2rem;

  ${tabletPortrait(css`
    display: none;
  `)}
`
